'use strict';
var basesearchSearch = require('base/search/search');
var slickHelper = require('../utils/slick');
var customUtil = require('../customUtil');
var plpAddToCart = require('../components/plpAddToCart');
var myFitSelected = [];

var appendParamToURL = function (url, name, value) {
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
        return url;
    }
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + name + '=' + encodeURIComponent(value);
};

var stringToHash = function (string) {
    // Converts to 32bit integer
    var hash = 0;

    if (string.length === 0) return hash;

    for (var i = 0; i < string.length; i++) {
        var char = string.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash;
    }
    return hash;
};

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Initializes category refinement slick slider on mobile
 */
function initCategoryRefinements() {
    var categoryRefinementsSelector = '.categories-ul';
    if ($(categoryRefinementsSelector).length > 0 && $(categoryRefinementsSelector).children('li').length > 1) {
        var allSlidesWidths = 0;
        $(categoryRefinementsSelector).find('.child-selected').each(function (index, tag) {
            allSlidesWidths += $(tag).outerWidth();
        });
        if ($(window).width() <= 992 && allSlidesWidths > $(categoryRefinementsSelector).outerWidth()) {
            if ($(categoryRefinementsSelector).hasClass('slick-initialized')) {
                $(categoryRefinementsSelector).slick('unslick');
            }
            $(categoryRefinementsSelector).slick({
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                variableWidth: true,
                slidesToScroll: 1,
                arrows: true,
                draggable: true,
                touchMove: true,
                swipeToSlide: true,
                swipe: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: 'unslick'
                    }
                ]
            });
        } else if ($(categoryRefinementsSelector).hasClass('slick-initialized')) {
            $(categoryRefinementsSelector).slick('unslick');
        }
    }
}

/**
 * Replaces and reinitializes category refinements on mobile
 * @param {Object} $results - jQuery object/element
 */
function handleCategoryRefinements($results) {
    $('.category-refinements-container').empty().html($results.find('.category-refinements-container').html());
    setTimeout(function () {
        initCategoryRefinements();
    }, 100);
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector)
        .empty()
        .html($updates.html());
    $('.update-count-header').html($('.update-count').html());
    if ($('.search-page-product-count').length > 0) {
        $('.search-page-product-count').html($results.find('.search-page-product-count').html());
    }

    /* update the category breadcrumb based on the selected category in the refinement */
    if ($('.category-breadcrumb').length > 0) {
        $('.category-breadcrumb').html($results.find('.ajax-category-breadcrumb').html());
    }

    /* update the search result banner based on the selected category in the refinement */
    var $searchResultBannerEl = $('.search-result-banner');
    if ($searchResultBannerEl.length > 0) {
        $searchResultBannerEl.html($results.find('.ajax-search-result-banner').html());
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 *
 * Updates SEO copy block
 * @param {Object} $results - jQuery DOM element
 */
function handleSEOCopy($results) {
    var $parentDiv = $('<div/>').html($results);
    updateDom($parentDiv, '.seo-copy-block');
}

/**
 * Updates sort refine bar on refinement selection
 * @param {Object} $results - jQuery DOM element
 */
function handleSortRefineBar($results) {
    var selectedSortOrderOptionSelector = $('.sort-refine-bar input:checked').attr('id');
    $results.find('#' + selectedSortOrderOptionSelector).attr('checked', true);

    updateDom($results, '.sort-refine-bar');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        '.seo-copy-block': handleSEOCopy,
        '.category-refinements-container': handleCategoryRefinements,
        '.sort-refine-bar': handleSortRefineBar
    };

    // Update DOM elements that do not require special handling
    ['.grid-header', '.header-bar', '.header.page-title', '.product-grid', '.show-more', '.filter-bar'].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

$('body').on('search:updateProducts', function (e, refinementUrl) {
    var singleRefinement;
    var categoryURL = $('.category-search-header').data('href');
    if (categoryURL) {
        if (refinementUrl) {
            var categoryTitle;
            if (customUtil.getCookie('plpCategoryTitle')) {
                categoryTitle = customUtil.getCookie('plpCategoryTitle').replace(/["]/g, '');
            } else {
                categoryTitle = document.title;
            }
            var refinements = refinementUrl.match(/(prefn[\d])/g);
            if (refinements) {
                var url = categoryURL.split('/?');
                var newUrl = url[0];
                var refinementCount = 0;
                for (var i = 0; i < refinements.length; i++) {
                    if (customUtil.getUrlQueryParameterValue(refinements[i], refinementUrl) !== 'size') {
                        var prefvMatched = refinements[i].replace(/n(\d)/, 'v$1');
                        var refinementValue = customUtil.getUrlQueryParameterValue(prefvMatched, refinementUrl);
                        var isMultiple = refinementValue.includes('+');
                        if (!isMultiple) {
                            singleRefinement = refinementValue.charAt(0).toUpperCase() + refinementValue.slice(1).toLowerCase();
                        }
                        if (refinementValue) {
                            refinementCount += 1;
                            if (refinementCount === 1) {
                                if (newUrl.slice(-1) === '/') {
                                    newUrl = newUrl + refinementValue;
                                } else {
                                    newUrl = newUrl + '/' + refinementValue;
                                }
                            } else {
                                newUrl = newUrl + '.' + refinementValue;
                            }
                        }
                    }
                }
                if (url[1]) {
                    newUrl = newUrl + '/?' + url[1];
                }
                history.pushState('', '', newUrl);
                if (refinements.length === 1 && singleRefinement) {
                    document.title = singleRefinement + ' ' + categoryTitle;
                    $('[rel="canonical"]').attr('href', customUtil.removeQueryParam(newUrl));
                    $('[name="robots"]').attr('content', 'index,follow');
                } else {
                    document.title = categoryTitle;
                    $('[name="robots"]').attr('content', 'noindex,nofollow');
                    $('[rel="canonical"]').attr('href', customUtil.removeQueryParam(categoryURL));
                }
            } else {
                document.title = categoryTitle;
                history.pushState('', '', categoryURL);
                $('[name="robots"]').attr('content', 'index,follow');
                $('[rel="canonical"]').attr('href', customUtil.removeQueryParam(categoryURL));
            }
        } else {
            history.pushState('', document.title, categoryURL);
        }
    }

    $('.category-marketing-slot').each(function (_index, categoryMarketingSlot) {
        if (categoryMarketingSlot && categoryMarketingSlot.children.length === 0) {
            categoryMarketingSlot.remove();
        }
    });
});

window.pushLinkTohistory = false;

/**
 * Set category url in the window history for back to PLP navigation
 */
function pdpToPlpNavigation() {
    $('body').on('click', '.plp-search-results .product-tile .image-container a', function () {
        if ($('.permalink').length > 0) {
            var url = $('.permalink').attr('value');
            if (window.pushLinkTohistory === true) {
                window.history.pushState({}, '', url);
            }
        }
    });
}

/* navigate to the previously selected product from PDP to PLP */
var goToPreviouslySelectedProduct = function () {
    if (sessionStorage.getItem('prevPlpScrollPos')) {
        // window.scrollTo({ top: sessionStorage.getItem('prevPlpScrollPos') });
        sessionStorage.removeItem('prevPlpScrollPos');
        window.history.scrollRestoration = 'auto';
    }
};

/**
 * reinitialize the plp image carousel on load more
 *
 * @param {HTMLElement} $el - HTML target element
 * @param {Object} slickConfigs - slick carousel options
 */
function reinitPLPImageCarousel($el, slickConfigs) {
    if (customUtil.isEmpty($el) && Object.keys(slickConfigs).length === 0) return;

    slickHelper.reinitCarousel($el, slickConfigs);
}

var generateUrl = function (catId, myFitCookie, url) {
    myFitSelected.push(catId);
    var catSizes = myFitCookie[catId];
    var prefMatched = url.match(/(prefn[\d])=size/); // find size preferences
    if (prefMatched && prefMatched.length) {
        var prefvMatched = prefMatched[1].replace(/n(\d)/, 'v$1'); // find equivalent size preference values
        var re = new RegExp(prefvMatched + '=([^&]*)');
        // If size values exist in cookie, replace them in url with these values
        // else remove size pref and values in url
        if (catSizes) {
            url = url.replace(re, prefvMatched + '=' + catSizes.join('|'));
            return url;
        }

        var rePrefn = new RegExp('prefn[\\d]=size&?');
        var rePrefv = new RegExp(prefvMatched + '=([^&]*)&?');
        return url.replace(rePrefn, '').replace(rePrefv, '');
    }

    prefMatched = url.match(/prefn[\d]/g);
    var prefName = 'prefn1';
    var prefValue = 'prefv1';
    if (prefMatched && prefMatched.length) {
        prefName = 'prefn' + (prefMatched.length + 1);
        prefValue = 'prefv' + (prefMatched.length + 1);
    }
    url = appendParamToURL(url, prefName, 'size');
    return appendParamToURL(url, prefValue, catSizes.join('|'));
};

var updateSortingRule = function ($sortOrderOption) {
    var srule = $sortOrderOption.attr('id').split('sortOrder')[1];

    $('.filter-options').each(function () {
        var currentDataHref = $(this).attr('data-href');
        var newSruleString = `&srule=${srule}`;
        var newDataHref;
        if (currentDataHref.indexOf('&srule') > -1) {
            newDataHref = currentDataHref.split('&srule')[0] + newSruleString;
        } else {
            newDataHref = currentDataHref += newSruleString;
        }
        $(this).attr('data-href', newDataHref);
    });
};

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container, .container-fluid').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results, .container-fluid.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(document).on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results, .container-fluid.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: basesearchSearch.fresize,

    sort: function () {
        $('.container, .container-fluid').on('change', 'select[name=sort-order]', function (e) {
            e.preventDefault();

            $(this).trigger('search:sort', [this.value, this.options[this.options.selectedIndex].text]);
            $.spinner().start();
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid')
                        .empty()
                        .html(response);
                    $('body').trigger('search:updateProducts');
                    $.spinner().stop();
                    window.pushLinkTohistory = true;
                },
                complete: function () {
                    $("body").trigger('refresh:productTile:carousel');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        $('.refinement-bar').on('change', 'input[name=sort-order]', function (e) {
            e.preventDefault();
            var $sortOrderOption = $(this);

            $(this).trigger('search:sort', this.value);
            $.spinner().start();
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid')
                        .empty()
                        .html(response);
                    updateSortingRule($sortOrderOption);
                    $('body').trigger('search:updateProducts');
                    $.spinner().stop();
                    window.pushLinkTohistory = true;
                },
                complete: function () {
                    $('body').trigger('refresh:productTile:carousel');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container, .container-fluid').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            var configs = {
                lazyLoad: 'ondemand',
                arrows: false,
                dots: true
            };
            var $plpSearchResultsElement = $('.js-plp-search-results');

            e.preventDefault();

            $(this).addClass('loading');

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $('body').trigger('search:updateProducts');
                    if (!customUtil.isEmpty($plpSearchResultsElement) && customUtil.isMobile()) {
                        var $targetEl = $plpSearchResultsElement.find('.product-tile .image-container .plp-slider');
                        configs.mobileFirst = true;
                        reinitPLPImageCarousel($targetEl, configs);
                        $plpSearchResultsElement.find('.product-tile .image-container').addClass('plp-mobile');
                    }
                    $.spinner().stop();
                    $('.btn.btn-outline-primary.col-12.col-sm-4.button-secondary').show();
                    $(this).removeClass('loading');
                    window.pushLinkTohistory = true;
                    // Affirm SI-1635
                    if (typeof affirm !== 'undefined') {
                        affirm.ui.refresh(); // eslint-disable-line no-undef
                    }
                },
                complete: function () {
                    $("body").trigger('refresh:productTile:carousel');
                },
                error: function () {
                    $.spinner().stop();
                    $(this).removeClass('loading');
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container, .container-fluid')
            .unbind('keydown')
            .on(
                'click keydown',
                '.refinement-details li button, .clear-refinements button, .refinements li button, .secondary-bar button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .category-refinements-container button.category, .refinement-category',
                function (e) {
                    if (e.type === 'click' || e.which === 13 || e.which === 32) {
                        e.preventDefault();
                        e.stopPropagation();

                        $(this).trigger('search:filter', e);

                        var urlStr = $(this).data('href');

                        var typeEvent = e.type;

                        // var for selected category
                        var selCat = $(this).hasClass('category');

                        var cgids = urlStr.match('cgid=([^&]*)');
                        if (cgids) {
                            var cgid = cgids[1];
                            $('#product-search-results')
                                .attr('data-cgid', cgid)
                                .data('cgid');
                        }

                        var url = $(this).data('href');

                        if ($(e.target).hasClass('reset')) {
                            myFitSelected.pop();
                            url = $(e.target).data('href');
                            url = appendParamToURL(url, 'fitToggle', 'false');
                        } else if (selCat && !myFitSelected.length) {
                            var $myFitToggle = $('.myfit-toggle');
                            var myFitToggleOn = $myFitToggle.is(':checked');
                            if (myFitToggleOn) {
                                try {
                                    var catId = url.match('cgid=([^&]*)')[1];
                                    var myfit = customUtil.getCookie('myFit');
                                    var myFitCookie = JSON.parse(JSON.parse(myfit));
                                    if (myFitCookie) {
                                        myFitSelected.push(catId);
                                        var catSizes = myFitCookie[catId];
                                        var prefMatched = url.match(/(prefn[\d])=size/); // find size preferences
                                        if (prefMatched && prefMatched.length) {
                                            var prefvMatched = prefMatched[1].replace(/n(\d)/, 'v$1'); // find equivalent size preference values
                                            var re = new RegExp(prefvMatched + '=([^&]*)');
                                            // If size values exist in cookie, replace them in url with these values
                                            // else remove size pref and values in url
                                            if (catSizes) {
                                                url = url.replace(re, prefvMatched + '=' + catSizes.join('|'));
                                            }
                                        } else {
                                            prefMatched = url.match(/prefn[\d]/g);
                                            var prefName = 'prefn1';
                                            var prefValue = 'prefv1';
                                            if (prefMatched && prefMatched.length) {
                                                prefName = 'prefn' + (prefMatched.length + 1);
                                                prefValue = 'prefv' + (prefMatched.length + 1);
                                            }
                                            url = appendParamToURL(url, prefName, 'size');
                                            url = appendParamToURL(url, prefValue, catSizes.join('|'));
                                        }
                                        // Create hash for url caching
                                        var hashValue = stringToHash(myfit);
                                        url = appendParamToURL(url, 'fitHash', hashValue);
                                    }
                                } catch (err) {
                                    window.console.error(e.message);
                                }
                            }
                        }

                        $.spinner().start();

                        $.ajax({
                            url: url,
                            data: {
                                page: $('.grid-footer').data('page-number'),
                                selectedUrl: url
                            },
                            method: 'GET',
                            success: function (response) {
                                if (response.redirect) {
                                    window.location.href = response.redirect;
                                    return;
                                }
                                parseResults(response);

                                $('body').trigger('search:updateProducts', url);
                                if (typeEvent !== 'click' && selCat !== false) {
                                    setTimeout(function () {
                                        $('.selected.category').focus();
                                    }, 0);
                                }
                                window.pushLinkTohistory = true;
                            },
                            complete: function () {
                                $("body").trigger('refresh:productTile:carousel');
                                $.spinner().stop();
                            }
                        });
                    }
                }
            );
    },
    resetMyFit: function () {
        // Handle refinement value selection and reset click
        $('.container,  .container-fluid').on('change', '.myfit-toggle', function (e) {
            e.stopImmediatePropagation();
            var myFitCookie;
            var selected = $(this).is(':checked');
            var url = $(this).data('url');

            url = url.replace(/&?fitToggle=([^&]*)/, '');
            var catId = url.match('cgid=([^&]*)')[1];

            if (selected) {
                // Initialize myFit sizes from cookie
                try {
                    var myfit = customUtil.getCookie('myFit');
                    myFitCookie = JSON.parse(JSON.parse(myfit));
                    if (myFitCookie) {
                        url = generateUrl(catId, myFitCookie, url);
                        // Create hash for url caching
                        var hashValue = stringToHash(myfit);
                        url = appendParamToURL(url, 'fitHash', hashValue);
                    }
                } catch (err) {
                    window.console.error(err.message);
                }
                url = appendParamToURL(url, 'fitToggle', 'true');
                sessionStorage.myFitToggle = 'on';
            } else {
                // Remove myFit sizes. Leave non-myFit sizes.
                try {
                    myFitSelected.pop();
                    myFitCookie = JSON.parse(JSON.parse(customUtil.getCookie('myFit')));
                    if (myFitCookie) {
                        var catSizes = myFitCookie[catId];
                        var prefMatched = url.match(/(prefn[\d])=size/); // find size preferences
                        if (prefMatched && prefMatched.length) {
                            var prefvMatched = prefMatched[1].replace(/n(\d)/, 'v$1'); // find equivalent size preference values
                            var re = new RegExp(prefvMatched + '=([^&]*)');
                            var sizesUrl = url.match(re);
                            if (sizesUrl[1]) {
                                // Replace size preference values
                                var sizesArr = decodeURIComponent(sizesUrl[1]).split('|');
                                var nonMyFitSizes = sizesArr.filter(function (size) {
                                    return catSizes.indexOf(size) < 0;
                                });
                                url = url.replace(re, prefvMatched + '=' + nonMyFitSizes.join('|'));
                            }
                        }
                    }
                } catch (err) {
                    window.console.error(err.message);
                }
                url = appendParamToURL(url, 'fitToggle', 'false');
                sessionStorage.myFitToggle = 'off';
            }

            var typeEvent = e.type;
            // var for selected filter options
            var idStr = $(this).data('id');

            // var for selected category
            var selCat = $(this).hasClass('category');

            $.spinner().start();

            $.ajax({
                url: url,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: url
                },
                method: 'GET',
                success: function (response) {
                    $.spinner().stop();
                    if (response.emailSignUpCookieName) {
                        var emailSignUpCookieName = customUtil.getCookie(response.emailSignUpCookieName);
                        if (emailSignUpCookieName) {
                            return;
                        }
                    }
                    parseResults(response);
                    $('body').trigger('search:updateProducts');
                    if (typeEvent !== 'click' && idStr !== undefined) {
                        setTimeout(function () {
                            $('.' + idStr).focus();
                        }, 0);
                    }
                    if (typeEvent !== 'click' && selCat !== false) {
                        setTimeout(function () {
                            $('.selected.category').focus();
                        }, 0);
                    }
                    window.pushLinkTohistory = true;
                },
                complete: function () {
                    $("body").trigger('refresh:productTile:carousel');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    loadMyFit: function () {
        if (sessionStorage.myFitToggle && sessionStorage.myFitToggle === 'off') {
            return;
        }
        var myfit = customUtil.getCookie('myFit');
        if (!myfit) {
            return;
        }

        if (window.location.href.indexOf('myfit') !== -1) {
            return;
        }

        var $loginLink = $('.login-link');
        if ($loginLink.length) {
            return;
        }

        var $myFitToggle = $('.myfit-toggle');
        var url = window.location.href;
        if ($myFitToggle.length > 0) {
            url = $myFitToggle.data('url');
        } else {
            return;
        }
        var catId = url.match('cgid=([^&]*)')[1];
        if (!catId) {
            return;
        }
        if (!url) {
            return;
        }
        try {
            myfit = customUtil.getCookie('myFit');
            var myFitCookie = JSON.parse(JSON.parse(myfit));
            if (myFitCookie) {
                url = generateUrl(catId, myFitCookie, url);
            }
        } catch (err) {
            window.console.error(err.message);
        }
        url = appendParamToURL(url, 'fitToggle', 'true');
        url = appendParamToURL(url, 'myfit', 'true');

        $.spinner().start();
        $('body').css('overflow-y', 'hidden');
        $.ajax({
            url: url,
            data: {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: url
            },
            method: 'GET',
            success: function (response) {
                $('body').css('overflow-y', 'auto');
                if (response.redirect) {
                    return;
                }
                parseResults(response);
                $('body').trigger('search:updateProducts');
                window.pushLinkTohistory = true;
            },
            error: function () {
                $('body').css('overflow', 'auto');
            },
            complete: function () {
                $.spinner().stop();
            }
        });
    },
    showContentTab: basesearchSearch.showContentTab,
    pdpToPlpNavigation: pdpToPlpNavigation,
    goToPreviouslySelectedProduct: goToPreviouslySelectedProduct,
    initHistory: function () {
        var previousHistoryState;
        var doNotPushHistory = false;

        /**
         * Listen to all possible AJAX calls on a search page (Filters, sorting, show more, ...).
         */
        $(document).ajaxSuccess(function (event, xhr) {
            // Make the assumption that a product-tile being present in the response means a grid-refresh
            if (xhr.responseText.indexOf('<div class="product-tile">') >= 0) {
                if (!doNotPushHistory) {
                    setTimeout(function () {
                        history.pushState({ reapplyFilters: true }, document.title, decodeURI($('.permalink').val()));
                    });
                }

                doNotPushHistory = false;
            }
        });

        /**
         * Listen to the back and forward button of the browser to detect URL changes.
         */
        window.addEventListener('popstate', function () {
            if ((history.state && history.state.reapplyFilters) || (previousHistoryState && previousHistoryState.reapplyFilters)) {
                var $resetButton = $('.refinement-bar button.reset');

                previousHistoryState = history.state;

                // This async call should not cause a new history state to be pushed.
                doNotPushHistory = true;

                // Use the reset button listeners to do a refresh
                $resetButton.data('href', decodeURI(window.location.href));
                $resetButton.trigger('click');
            }
        });
    },
    categoryRefinements: function () {
        $(window).on('load', function () {
            initCategoryRefinements();
        });

        $(window).on('resize', function () {
            initCategoryRefinements();
        });
    },
    initPLPAddToBag: plpAddToCart.initAddToBag()
};
